import React from 'react';
import { Box, Alert, IconButton, Collapse } from '@mui/material';
import { X, AlertTriangle } from 'react-feather';

type WarningBannerProps = {
  show: boolean;
  title: string;
  message: string;
  onDismiss?: () => void;
};

export const WarningBanner = ({
  show,
  title,
  message,
  onDismiss,
}: WarningBannerProps) => {
  if (!show) return null;

  return (
    <Box mb={2}>
      <Collapse in={show}>
        <Alert
          severity="warning"
          icon={<AlertTriangle size={16} />}
          action={
            <IconButton aria-label="close" size="small" onClick={onDismiss}>
              <X size={16} />
            </IconButton>
          }
          sx={(theme) => ({
            backgroundColor: theme.palette.yellow[50],
            border: `1px solid ${theme.palette.grey[300]}`,
            borderRadius: '4px',
            color: theme.palette.text.primary,
            '.MuiAlert-icon': {
              color: theme.palette.text.primary,
            },
          })}
        >
          <strong>{title}</strong>
          <br />
          {message}
        </Alert>
      </Collapse>
    </Box>
  );
};
